/**
 * The Step component renders the JSX returned by its `render` prop, but only if the step
 * corresponding to its `name` prop is the current step.
 */
const Step = ({ name, current, render }) =>
    (Array.isArray(name) && name.includes(current)) || current === name
        ? render()
        : null;

export default Step;
